import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../core/providers/AuthProvider';
import { usePostDetails } from '../../../../shared/hooks/usePostDetails';
import { useActivityNavigation } from '../../../../shared/hooks/useActivityNavigation';
import { useParticipation } from '../../../../features/posts/hooks/useParticipation';
import ActivityDetails from '../../../../shared/components/ActivityDetails';
import { Text } from '../../../../core/design-system/components/Text';
import { Icon } from '../../../../core/design-system/components/Icon';
import './styles.css';

const ActivityDetailsPage = ({ activityIdOverride, onBack: onBackProp }) => {
  const { id: idFromParams } = useParams();
  // Utiliser l'ID passé en prop si disponible, sinon celui de l'URL
  const id = activityIdOverride || idFromParams;
  
  const { t } = useTranslation(['activities', 'common']);
  const { user } = useAuth();
  const { post, loading, error } = usePostDetails(id);
  const { goBack: goBackNav } = useActivityNavigation();
  const { toggleParticipation } = useParticipation(post);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const autoShare = params.get('share') === 'true';
  
  // Utiliser le callback onBack si fourni, sinon la navigation
  const goBack = onBackProp || goBackNav;
  
  // Handler pour le bouton participer/quitter
  const handleParticipationToggle = async () => {
    if (!post) return;
    
    try {
      await toggleParticipation();
    } catch (error) {
      console.error('Erreur lors de la participation:', error);
      // Gérer l'erreur si besoin (toast, etc.)
    }
  };
  
  if (loading) {
    return (
      <div className="activity-details-page">
        <div className="activity-details-loading">
          <Icon name="loader" size={32} className="activity-details-spinner" />
          <Text variant="body">{t('common:loading')}</Text>
        </div>
      </div>
    );
  }
  
  if (error || !post) {
    return (
      <div className="activity-details-page">
        <div className="activity-details-error">
          <Icon name="alert-triangle" size={32} />
          <Text variant="body">
            {error ? error.message : t('common:errors.not_found')}
          </Text>
          <button className="activity-details-back-btn" onClick={goBack}>
            {t('common:actions.back')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="activity-details-page">
      <ActivityDetails
        activity={post}
        currentUser={user}
        onJoin={handleParticipationToggle}
        onLeave={handleParticipationToggle}
        onBack={goBack}
        autoShare={autoShare}
      />
    </div>
  );
};

export default ActivityDetailsPage; 